import { AbstractControl, Validators } from '@angular/forms';
import { createValidationError, PcsValidationErrors } from '@app/shared/validators/validation-errors';

const defaultMessage = 'general.message.invalid.email';

export const emailValidator = (message: string = defaultMessage) =>
  (control: AbstractControl): PcsValidationErrors => {
    if (Validators.email(control)) {
      return createValidationError('email', message);
    }
  };
